export default "__VITE_ASSET__ba4ce5ee__"